'use client'

import { useEffect, useRef } from 'react'

import useMycleContentsQuery from '../api/query/useMycleContentsQuery'
import { carStoryTracking } from '../lib'
import { MYCLE_CONTENT_MENU } from '../model'
import CarStoryTabError from './CarStoryTabError'
import CarStoryTabLoading from './CarStoryTabLoading'
import NowContentsSection from './NowContentsSection'

const CarStoryNowPage = () => {
  const { data, isLoading, isError, refetch } = useMycleContentsQuery({
    menu: MYCLE_CONTENT_MENU.NOW,
  })

  const hasTrackedRef = useRef(false)
  useEffect(function trackNowPageView() {
    if (hasTrackedRef.current) return
    hasTrackedRef.current = true
    carStoryTracking.showNowPage()
  }, [])

  if (isLoading) return <CarStoryTabLoading />
  if (isError || !data) return <CarStoryTabError onRetry={refetch} />

  return <NowContentsSection items={data.content ?? []} />
}

export default CarStoryNowPage
